import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { CardProps } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { rem } from '@helpers';
import { useMemo } from 'react';

interface SummaryNextStepsHelperOutput {
	resources: CardPromotionCodeResources;
	cardProps: CardProps;
}

interface CardPromotionCodeResources {
	nextStepsTitle: string;
	iziBiziEmailAccessTitle: string;
	iziBiziEmailAccessDescription: string;
	companyCreationTitle: string;
	companyCreationDescription: string;
	contactTitle: string;
	contactDescription: string;
	learnHow: string;
	loginToIziBizi: string;
	backToHomepage: string;
	changeEmailTooltip: string;
	knowHowUrl: string;
	goToIzibiziUrl: string;
}

export const useSummaryNextStepsHelper = (): SummaryNextStepsHelperOutput => {
	const t = useTranslation();

	const cardProps = {
		boxShadow: '0px 2px 4px #E1E1E1',
		marginTop: 0,
		marginRight: 0,
		marginBottom: 0,
		marginLeft: 0,
		borderRadius: rem(8),
		paddingBottom: rem(16),
		paddingTop: rem(16),
	} as CardProps;

	const resources = useMemo(() => {
		return {
			nextStepsTitle: t('placeholders.subscriptionConclusion.body.nextStepsTitle'),
			iziBiziEmailAccessTitle: t('placeholders.subscriptionConclusion.body.iziBiziEmailAccessTitle'),
			iziBiziEmailAccessDescription: t('placeholders.subscriptionConclusion.body.iziBiziEmailAccessDescription'),
			companyCreationTitle: t('placeholders.subscriptionConclusion.body.companyCreationTitle'),
			companyCreationDescription: t('placeholders.subscriptionConclusion.body.companyCreationDescription'),
			contactTitle: t('placeholders.subscriptionConclusion.body.contactTitle'),
			contactDescription: t('placeholders.subscriptionConclusion.body.contactDescription'),
			learnHow: t('placeholders.subscriptionConclusion.body.learnHow'),
			changeEmailTooltip: t('placeholders.subscriptionConclusion.body.changeEmailTooltip'),
			loginToIziBizi: t('general.loginToIziBizi'),
			backToHomepage: t('general.backToHomepage'),
			knowHowUrl: t('placeholder.subscriptionConclusion.knowHow.url'),
			goToIzibiziUrl: t('placeholder.subscriptionConclusion.button.goToIzibizi.url'),
			navigateMbcp: t('general.exit.navigateMbcp'),
			navigateIzibizi: t('general.exit.navigateIzibizi'),
		};
	}, [t]);

	return { resources, cardProps };
};
